import Member from "@sentrei/common/models/Member";

import {timestamp} from "@sentrei/functions/__mocks__/firebase-testing";

import {profileResponse} from "./Profile";

export const viewerMemberResponse: Member.Response = {
  ...profileResponse,
  uid: "userId",
  joined: timestamp,
  role: "viewer",
};

export const moderatorMemberResponse: Member.Response = {
  ...profileResponse,
  uid: "userId",
  joined: timestamp,
  role: "moderator",
};

export const adminMemberResponse: Member.Response = {
  ...profileResponse,
  uid: "userId",
  joined: timestamp,
  role: "admin",
};
